import anime from 'animejs'
import eventBus from '@/core/modules/eventBus'

const view = {
	async onEnter({ next, ...rest }) {
		window.scrollTo(0, 0)

		const { newHtml } = rest

		anime({
			targets: newHtml,
			duration: 500,
			opacity: [0, 1],
			complete: () => next()
		})
	},

	async onExit({ next, ...rest }) {
		const { oldHtml } = rest

		anime({
			targets: oldHtml,
			duration: 500,
			opacity: [1, 0],
			complete: () => {
				eventBus.emit('menu:close')
				next()
			}
		})
	}
}

const homepage = {
	async onEnter({ next, ...rest }) {
		window.scrollTo(0, 0)

		const { newHtml } = rest

		document.body.setAttribute('data-page', 'homepage')

		anime({
			targets: newHtml,
			duration: 500,
			opacity: [0, 1],
			complete: () => next()
		})
	},

	async onExit({ next, ...rest }) {
		const { oldHtml } = rest

		document.body.setAttribute('data-page', '')

		anime({
			targets: oldHtml,
			duration: 500,
			opacity: [1, 0],
			complete: () => {
				eventBus.emit('menu:close')
				next()
			}
		})
	}
}

export default [
	{
		path: '/',
		name: 'home-page',
		view: homepage
	},
	{
		path: '*',
		name: 'default',
		view
	}
]


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
